const specialSegmentCelebritiesData = [
    {'name': 'American Queen', 'possessivePronoun': 'her'},
    {'name': 'Prezz', 'possessivePronoun': 'him'},
    {'name': 'Big T', 'possessivePronoun': 'him'}
];

let segmentsData = {
  "Feud Package": {
    "start": "A video package airs about the feud between {0} and {4} ...",
    "action": "It focused on {0}",
    "choices": [
      "a training montage of {0} and {4} as they prepare to face each other.",
      "a recalling of the history between {0} and {4}.",
      "a recap of the backstage encounters between {0} and {4}.",
      "in-ring highlights of the previous encounters between {0} and {4}.",
      "highlights of their rivalry with an awesome music track.",
      "interviews by those close to {0} and {4} about their rivalry.",
      "interviews given by {0} and {4} about each other."
    ]
  },
  "Promo Battle": {
    "start": "{0} are in the ring with mics in hand ...",
    "action": "{0}",
    "choices": [
      "The conversation got personal, as they lined insult after insult at each other's families.",
      "They embarrassed each other about their worst in-ring losses.",
      "They sarcastically glorified each other's failures.",
      "They roasted each other's gear and looks.",
      "They took shots at each other's gimmicks.",
      "They slammed each other's lack of charisma.",
      "They guaranteed to expose the worst of each other.",
      "They criticized each other's ability to wrestle.",
      "They exposed each other's weaknesses to the fans.",
      "They belittled each other's accomplishments."
    ]
  },
  "Fight": {
    "start": "A camera crew is live with a fight between {0} ...",
    "action": "They went through an intense brawl {0}",
    "choices": [
      "at a popular local bar.",
      "backstage, fighting each other around the whole locker room.",
      "inside the arena's parking lot.",
      "in the streets outside the arena.",
      "at the nearby dance club.",
      "at the beach.",
      "at the local minigolf.",
      "inside the backstage boiler room.",
      "in the VIP catering section.",
      "outside the arena with a bunch of cheering fans.",
      "inside the owner's office.",
      "at a nearby bed & breakfast.",
      "at the nearby hotel's lobby.",
      "drunk in a dark alley.",
      "by the merch store.",
      "inside a grocery store.",
      "outside the local graveyard."
    ]
  },
  "Heat Promo": {
    "start": "{0} is in the ring for a promo ...",
    "startTag": "{0} are in the ring for a promo ...",
    "action": "{0}",
    "choices": [
      "{0} ran down the local sports team and made fun of their recent loss.",
      "{0} talked about being better than every person in the crowd.",
      "{0} demeaned the city and promised to never return to it.",
      "{0} degraded the people sitting in the crowd.",
      "{0} vented about being ashamed to perform in this city.",
      "{0} talked about how the people in the crowd will never amount to anything.",
      "{0} insulted the people in the crowd and called them losers."
    ]
  },
  "Spirited Promo": {
    "start": "{0} is in the ring for a promo ...",
    "startTag": "{0} are in the ring for a promo ...",
    "action": "{0}",
    "choices": [
      "{0} talked about {2} love for wrestling and promised to keep doing it as long as possible.",
      "{0} thanked the fans for coming out and for their support.",
      "{0} told the fans that they are the reason for {1} wrestling.",
      "{0} promised to go all-out in {2} next match.",
      "{0} spoke about {2} last injury and how the thought of coming out here brought {1} back.",
      "{0} talked about never wanting to do anything but this since childhood.",
      "{0} spoke about being happy to return to this city again."
    ]
  },
  "Midget Impersonation": {
    "start": "",
    "action": "{0} came to the ring and called {4} to come out ... A little person emerged from the back, dressed exactly like {4}. After some cruel jokes, {0} threw the little person out of the ring.",
    "actionTag": "{0} came to the ring and called {4} to come out ... Little people emerged from the back, dressed exactly like {4}. After some cruel jokes, {0} threw the little people out of the ring."
  },
  "Kidnapping": {
    "start": "A scheduled match is on hold because someone's missing ... ",
    "action": "People backstage say they saw some masked people force {4} into a car and abduct {5}! Could it be {0}?"
  },
  "Local Squash": {
    "start": "{0} is in the ring, calling out anyone for a match ...",
    "startTag": "{0} are in the ring, calling out anyone for a match ...",
    "action": "A local superstar, {4}, answered the challenge. {0} made short work of it, squashing the competitor in a quick match!",
    "actionTag": "Some local superstars, {4}, answered the challenge. {0} made short work of it, squashing the competitors in a quick match!"
  },
  "Talk Show": {
    "start": "{0} is in the ring for {2} talk show, inviting {8} and {4} as guests ... ",
    "startTag": "{0} are in the ring for {2} talk show, inviting {8} and {4} as guests ... ",
    "action": "{8} and {4} exchange some words before starting a brawl, with {0} unable to stop them!"
  },
  "Home Invasion": {
    "start": "A live camera crew is stationed outside what appears to be someone's house ... ",
    "action": "That's {4}'s house, and {0} is breaking in! The two end up brawling in front of {6} family!",
    "actionTag": "That's {4}'s house, and {0} are breaking in! The two end up brawling in front of {6} family!"
  },
  "Car Destruction": {
    "start": "The camera crew is in the parking lot ... ",
    "action": "{0} appeared, standing in front of {4}'s car, before destroying it with a baseball bat!"
  },
  "Masked Attacker": {
    "start": "",
    "action": "{4} walked down the ramp for a scheduled match when a masked person attacked {5} from behind! Could it be {0}?",
    "actionTag": "{4} walked down the ramp for a scheduled match when masked people attacked {5} from behind! Could it be {0}?"
  },
  "Promo Ambush": {
    "start": "",
    "action": "{4} started a promo in the ring when {0} appeared from behind to ambush {5}! What a cheap attack."
  },
  "Slander Competitor": {
    "start": "{0} is in the ring with a microphone, talking about a competitor ... ",
    "startTag": "{0} are in the ring with microphones, talking about a competitor ... ",
    "action": "{0}",
    "choices": [
      "{0} trashed their ratings.",
      "{0} told the fans how bad their last event was.",
      "{0} parodied their top wrestlers.",
      "{0} made fun of their booking.",
      "{0} ridiculed their owner's recent decisions.",
      "{0} mocked their in-ring product."
    ]
  },
  "Spooky Trick": {
    "start": "We're getting some flickering lights backstage ... ",
    "action": "A camera showed {4} wandering backstage when the hallway lights went out and a shadow appeared in front of {5}! Turns out it was only {0} with a scary antic."
  },
  "Slime Surprise": {
    "start": "A big veiled box is set up in the ring ... ",
    "action": "{0} invited {4} into the ring, promising a special gift to thank {5}. The box turned out to be empty, and a load of slime poured onto {4}!"
  },
  "Smack Talk": {
    "start": "{0} and {4} are both in the ring to talk ...",
    "action": "They trade insults and verbal blows, with {0} landing some serious digs at {4}."
  },
  "Singing Contest": {
    "start": "We have some musical equipment set up in the ring ...",
    "action": "{0} challenged {4} to a singing contest! They both sang along with the instruments. Seems like the crowd liked {0}'s performance more."
  },
  "Push-up Contest": {
    "start": "{0} and {4} are out here trying to see who is stronger, so they challenge each other to a push-up contest!",
    "action": "After {4} performed dozens of reps easily, {0} refused to participate and instead threw out the exhausted {4}!"
  },
  "Debut": {
    "start": "We're awaiting the debut of a new superstar ...",
    "action": "It's {0}! {0} is here! The fans are on their feet as they cheer {1} on!",
    "startTag": "We're awaiting the debut of a new team ...",
    "actionTag": "It's {0}! {0} are here! The fans are on their feet as they cheer {1} on!"
  },
  "Cash-In Tease": {
    "start": "The champion {4} is heading backstage after a tough match ...",
    "action": "{0}'s music hits! The champion retreats as {0} teases a cash-in, only to promise to do it at another time.",
    "startTag": "The champions {4} are heading backstage after a tough match ...",
    "actionTag": "{0}'s music hits! The champions retreat as {0} tease a cash-in, only to promise to do it another time."
  },
  "Anger Management": {
    "participants": {
      "2": {
        "start": "{0} and {4} are sitting outside a therapist's office ...",
        "action": "The therapist makes them talk it out, and after sharing grievances and anger, they all go for an awkward hug."
      },
      "3": {
        "start": "{0}, {4} and {8} are sitting outside a therapist's office ...",
        "action": "The therapist makes them talk it out, and after sharing grievances and anger, they all go for an awkward hug."
      }
    }
  },
  "Backstage BBQ": {
    "start": "Some smoke is coming out of a room backstage ...",
    "action": "{0} is hosting a backstage barbeque for the locker room! When a staff member cites fire safety and asks {1} to end it, {0} kicks him in the face.",
    "actionTag": "{0} are hosting a backstage barbeque for the locker room! When a staff member cites fire safety and asks {1} to end it, {0} kick him in the face."
  },
  "Contract Signing": {
    "start": "{0} and {4} are sitting across a table in the ring, with a contract between them ...",
    "action": "They both sign the contract and go for a handshake, but {0} strikes {4} before putting {5} through the table!",
    "actionTag": "They both sign the contract and go for a handshake, but {0} strike {4} before putting {5} through the table!"
  },
  "Exposing the Past": {
    "start": "",
    "action": "{0} is in the ring, promising to expose {4}. Footage plays on the titantron showing some vile moments from {4}'s past!"
  },
  "Title Disrespect": {
    "start": "A camera crew is live somewhere outside the arena with {0} ...",
    "action": "{0} has {4}'s title in {2} hands and asks {5} to come get it, but ends up throwing it in a lake behind {1}!",
    "actionTag": "{0} have {4}'s titles in {2} hands and ask {5} to come get it, but end up throwing them in a lake behind {1}!"
  },
  "Demand Title Shot": {
    "start": "{0} is coming out to the ring to talk about who to face next ...",
    "action": "{0} calls out {4} and demands a title match! {4} answers and holds {6} title up.",
    "actionTag": "{0} call out {4} and demand a title match! {4} answer and hold {6} titles up."
  },
  "Champion Coronation": {
    "start": "The ring is decorated for a celebration as {0} is coming out alongside the owner of the company ...",
    "action": "{0} is presented with the title and wears it with pride as the owner applauds {2} title victory!",
    "startTag": "The ring is decorated for a celebration as {0} are coming out alongside the owner of the company ...",
    "actionTag": "{0} are presented with the titles and wear them with pride as the owner applauds {2} title victory!"
  },
  "Epic Brawl": {
    "start": "{0} is calling out {4} to come to the ring and face {1} ...",
    "action": "The two go at each other with full force! The locker room comes out to separate them but they continue to pummel each other!",
    "startTag": "{0} are calling out {4} to come to the ring and face {1} ...",
    "actionTag": "The two go at each other with full force! The locker room comes out to separate them but they continue to pummel each other!"
  },
  "Team Tension": {
    "participants": {
      "2": {
        "start": "{0} and {4} are coming to the ring to discuss their recent string of bad performances ...",
        "action": "Both members end up blaming each other for their losses as tensions rise between them."
      },
      "3": {
        "start": "{0}, {4} and {8} are coming to the ring to discuss their recent string of bad performances ...",
        "action": "All three members end up blaming each other for their losses as tensions rise between them."
      }
    }
  },
  "Unlikely Partners": {
    "start": "{0} and {4} are fighting against each other here as the owner comes out to stop them ...",
    "action": "The owner makes them partners in a tag match! They almost have the match won when {4} turns on {0} and they end up losing the match.",
    "actionTag": "The owner makes them partners in a tag match! They almost have the match won when {4} turn on {0} and they end up losing the match."
  },
  "Legend's Praise": {
    "start": "{0} and {4} are out here in the ring when {8}'s music hits!",
    "action": "{8} shakes everyone's hands, then gives {10} personal opinion that {0} is better than {4} and can't be beaten.",
    "actionTag": "{8} shake everyone's hands, then give {10} personal opinion that {0} are better than {4} and can't be beaten."
  },
  "This Belongs To You": {
    "start": "The owner of the company is here with the title and calls out {0} ...",
    "startTag": "The owner of the company is out with the titles and calls out {0} ...",
    "action": "The owner praises {1} and asserts {2} right to be champion. {0} is awarded the title!",
    "actionTag": "The owner praises {1} and asserts {2} right to be champions. {0} are awarded the titles!"
  },
  "You're Fired": {
    "start": "The owner of the company is out here in a serious mood and calls out {0} ...",
    "action": "The owner tears into {0}, builds it up, then fires {1}! {0} can't believe it."
  },
  "Lost My Smile": {
    "start": "{0} comes to the ring looking dispirited and stands in the middle with downcast eyes ...",
    "action": "{0} states {2} unhappiness with {2} current position in life and doesn't feel like being the champion anymore. {0} vacates {2} title!",
    "actionTag": "{0} state {2} unhappiness with {2} current position in life and don't feel like being the champions anymore. {0} vacate {2} titles!"
  },
  "Title Destruction": {
    "start": "The champion, {0}, is in the ring holding {2} title up high ...",
    "action": "{0} looks deeply at the title before throwing it behind {1} and then beating it to pieces with a steel chair!",
    "startTag": "The champions, {0}, are in the ring holding {2} titles up high ...",
    "actionTag": "{0} look deeply at the titles before throwing them behind {1} and then beating them to pieces with steel chairs!"
  },
  "Mutual Respect": {
    "start": "{0} calls out {4} to address their feud ...",
    "action": "The two of them tease a fight before going for a handshake of respect."
  },
  "Moving On": {
    "start": "",
    "action": "{0} talks about moving on from {2} feud with {4} towards bigger things. What could they be?"
  },
  "Vicious Beatdown": {
    "start": "{0} and {4} are out in the ring for a promo ...",
    "action": "Before {4} can even talk, {0} launches an attack on {5}! {0} mercilessly beats down {4} all around the ring. All people are asking is 'Why?'.",
    "startTag": "{0} and {4} are out in the ring for a promo ...",
    "actionTag": "Before {4} can even talk, {0} launch an attack on {5}! {0} mercilessly beat down {4} all around the ring. All people are asking is 'Why?'."
  },
  "Backstab": {
    "participants": {
      "2": {
        "start": "{0} and {4} are out in the ring, calling out their previous opponent ...",
        "action": "{0} grabs a chair and hits {4} in the back! What is going on?! {0} hits {2} finisher on {4} and then walks out of the ring with a look of disgust on {2} face."
      },
      "3": {
        "start": "{0}, {4} and {8} are out in the ring, calling out their previous opponent ...",
        "action": "{0} grabs a chair and hits {4} in the back! {8} looks on in shock and {0} beats {9} down too! {0} walks out of the ring with a look of disgust on {2} face."
      }
    }
  },
  "Beatdown Save": {
    "start": "{8} is beating down {4} in the ring. This isn't looking good for {4} as {8} continues to thrash {5} ...",
    "action": "It's {0}! {0} comes out to the ring and strikes down {8}, throwing {9} out of the ring! {4} and {0} embrace!",
    "startTag": "{8} are beating down {4} in the ring. This isn't looking good for {4} as {8} continue to thrash {5} ...",
    "actionTag": "It's {0}! {0} come out to the ring and strike down {8}, throwing {9} out of the ring! {4} and {0} embrace!"
  },
  "Forgiveness": {
    "start": "{0} calls out {4} to address their feud ...",
    "startTag": "{0} call out {4} to address their feud ...",
    "action": "{4} is cautious but {0} has had enough and asks for {6} forgiveness. {4} nods and then raises {0}'s hand! The crowd cheers!",
    "actionTag": "{4} are cautious but {0} have had enough and ask for {6} forgiveness. {4} look at each other, nod and then raise {0}'s hands! The crowd cheers!"
  },
  "Defying a Villain": {
    "participants": {
      "2": {
        "start": "{0} and {4} are out in the ring talking about how good they are ...",
        "action": "{0} confronts {4} about all the things they've done and refuses to take any more of {4}. {0} then hits {4} with {2} finisher!"
      },
      "3": {
        "start": "{0}, {4} and {8} are out in the ring talking about how good they are ...",
        "action": "{0} confronts {4} and {8} about all the things they've done and refuses to take any more of them. {0} hits {4} and then {8} with {2} finisher!"
      }
    }
  },
  "Delayed Vengeance": {
    "start": "{0} and {4} are out in the ring, teaming up for a tag match ...",
    "action": "Before their opponents can come out, {0} hits {4} from behind! {0} screams at {4} about never forgetting what {4} did to {1} and continues to beat {5} down!",
    "startTag": "{0} and {4} are out in the ring, teaming up for a match ...",
    "actionTag": "Before their opponents can come out, {0} hit {4} from behind! {0} scream at {4} about never forgetting what {4} did to {1} and continue to beat {5} down!"
  },
  "Joining the Devil": {
    "start": "{4} is laying a beating on {8}. Someone needs to come help {9} ...",
    "action": "{0} comes out to the ring. Finally! Wait, what's this?! {0} joins {4} as the two of them beat {8} helpless and then shake hands!",
    "startTag": "{4} are laying a beating on {8}. Someone needs to come help {9} ...",
    "actionTag": "{0} come out to the ring. Finally! Wait, what's this?! {0} join {4} as both of them beat {8} helpless and then shake hands!"
  },
  "Neutralize": {
    "start": "{0} is out in the ring with a mic in hand ...",
    "action": "{0} says some uncharacteristic things. The fans are unsure whether to cheer or boo {1}.",
    "startTag": "{0} are out in the ring with mics in hand ...",
    "actionTag": "{0} say some uncharacteristic things. The fans are unsure whether to cheer or boo {1}."
  },
  "Villainize": {
    "start": "{0} is out in the ring with a mic in hand ...",
    "action": "{0} berates the crowd and feels the fans owe {1} more respect. The fans start to turn on {1}.",
    "startTag": "{0} are out in the ring with mics in hand ...",
    "actionTag": "{0} berates the crowd and feel the fans owe {1} more respect. The fans start to turn on {1}."
  },
  "Build Honor": {
    "start": "{0} is out in the ring with a mic in hand ...",
    "action": "{0} is insistent on reclaiming lost honor and strives to work hard for it. The fans start to cheer {1}.",
    "startTag": "{0} are out in the ring with mics in hand ...",
    "actionTag": "{0} are insistent on reclaiming lost honor and strive to work hard for it. The fans start to cheer {1}."
  },
  "Video Package": {
    "start": "A video package airs about {0} ...",
    "action": "It focused on {0}",
    "choices": [
      "interviews by people close to {0}.",
      "training highlights of {0} getting ready to wrestle.",
      "a sit-down backstage interview with {0}.",
      "prominent people praising {0}.",
      "the ability of {0} in the ring.",
      "the story of {0} to get here.",
      "in-ring highlights of {0}'s wrestling career.",
      "{0} promoting the company outside the ring.",
      "a backstage monologue by {0} about {2} wrestling ability.",
      "the big wins of {0}'s career."
    ]
  },
  "Event Package": {
    "start": "A video package airs ...",
    "action": "It promoted and built hype for the upcoming monthly event."
  },
  "Debut Package": {
    "start": "A video package airs ...",
    "action": "It contained highlights of a new superstar, {0}."
  },
  "Return Package": {
    "start": "A video package airs ...",
    "action": "It showed {0} getting ready to return to the ring!"
  },
  "Career Package": {
    "start": "A video package airs ...",
    "action": "It showed highlights of the long and storied career of {0}."
  },
  "Day in the Life": {
    "start": "A video package airs ...",
    "action": "It focused on {0}",
    "choices": [
      "{0} going hunting for the day.",
      "{0} spending the whole day perfecting {2} wrestling ability.",
      "{0} spending a day at home with {2} family.",
      "{0} going for a picnic in the park with {2} family.",
      "{0} spending a day sun-bathing at the beach.",
      "{0} spending the day and night camping in the woods.",
      "{0} fishing in {2} boat all day long.",
      "{0} going trekking up the local hills.",
      "{0} dominating a local wrestling meet-up.",
      "{0} playing frisbee in the park with little kids and defeating them.",
      "{0} going swimming in the local lake and napping in the center of it."
    ]
  },
  "Competitor Buyout": {
    "start": "{0} is out in the ring to talk about the fate of {1} ...",
    "action": "{0} announces the purchase of {1}! {0} says the deal will be finalized soon and {1} will be no more. The fans are in awe."
  },
  "Champion Package": {
    "start": "A video package airs ...",
    "action": "It focused on {0}",
    "choices": [
      "the Championship Reign of {0}.",
      "how {0} won {2} Championship.",
      "how {0} surpasses the lineage of the Championship.",
      "the history of {0}'s Championship.",
      "{0} talking about how great {2} reign will be."
    ],
    "choicesTag": [
      "the Championship Reign of {0}.",
      "how {0} won {2} Championships.",
      "the lineage of the Championships and how {0} surpass it.",
      "the history of {0}'s Championships.",
      "{0} talking about how great {2} reign will be."
    ]
  },
  "Option C": {
    "start": "{0} comes out to the ring ...",
    "startTag": "{0} come out to the ring ...",
    "action": "{0} decides to invoke option C, vacating {2} Championship for a world title shot!",
    "actionTag": "{0} decide to invoke option C, vacating {2} Championships for a world title shot!"
  },
  "New Title Reveal": {
    "start": "{0} comes out to the ring ...",
    "startTag": "{0} come out to the ring ...",
    "action": "{0} reveals the new and customized version of {2} Championship!",
    "actionTag": "{0} reveal the new and customized versions of {2} Championships!"
  },
  "Championship Split": {
    "start": "The owner and {0} come out to the ring ...",
    "action": "The owner tells the fans about splitting {0}'s Championship into two and presents the new Championship!",
    "actionTag": "The owner tells the fans about splitting {0}'s Championships into two and presents the new Championships!"
  },
  "Entrance Parody": {
    "start": "",
    "action": "{4}'s music hits as ... Wait, it's actually {0} dressed in {4}'s gear! {0} mocks {6} entrance, doing the whole thing in an over the top way."
  },
  "Backstage Interview": {
    "start": "Our interviewer is backstage with {0} ...",
    "action": "{0}",
    "choices": [
      "{0} makes fun of the interviewer for all sorts of reasons.",
      "{0} talks about being the best performer in the locker room.",
      "{0} talks about being more than ready for {2} next match.",
      "{0} tells the interviewer to get lost and never disturb {1} again.",
      "{0} talks about how no one is above {1}."
    ],
    "choicesTag": [
      "{0} make fun of the interviewer for all sorts of reasons.",
      "{0} talk about being the best performers in the locker room.",
      "{0} talk about being more than ready for {2} next match.",
      "{0} tell the interviewer to get lost and never disturb {1} again.",
      "{0} talk about how no one is above {1}."
    ]
  },
  "Main Event Package": {
    "start": "A video package airs ...",
    "action": "It promoted and built hype for the main event of the show."
  },
  "Recap Package": {
    "start": "A video package airs ...",
    "action": "It went over the best part of the last show."
  },
  "Bodybuilding Contest": {
    "start": "{0} and {4} are in the ring and the lights are turned down ...",
    "action": "They do a variety of poses for the crowd before the contest devolves into a brawl! For what it's worth the crowd seemed to like {0}'s poses more."
  },
  "Spouse Affair": {
    "start": "",
    "action": "{4} is in the ring when {0} appears on the titantron, lying in bed. {4}'s spouse appears and joins {0} in bed! The video cuts away as {4} looks on, shattered.",
    "actionTag": "{4} are in the ring when {0} appear on the titantron, lying in bed. {4}'s spouses appear and join {0} in bed! The video cuts away as {4} look on, shattered."
  },
  "This Is My Life": {
    "start": "The ring is decorated as {0} comes out ...",
    "startTag": "The ring is decorated as {0} come out ...",
    "action": "{0} goes over all {2} accomplishments in life, bringing out past trophies, coaches singing {2} praise and messages of support from influential figures.",
    "actionTag": "{0} go over all {2} accomplishments in life, bringing out past trophies, coaches singing {2} praise and messages of support from influential figures."
  },
  "Siblings Parody": {
    "start": "",
    "action": "{0} brings three people pretending to be {4}'s siblings into the ring. They tell stories about how badly {4} treated them growing up.",
    "actionTag": "{0} bring three people pretending to be {4}'s siblings into the ring. They tell stories about how badly {4} treated them growing up."
  },
  "Backstage Attack": {
    "start": "",
    "action": "{0}",
    "choices": [
      "{4} is walking into the arena when {0} attacks {5} from behind! Superstars scramble backstage to pull {0} away from {4}.",
      "{0} is seen walking into {4}'s locker room. A scuffle is heard as cameras rush in to see {0} beating the hell out of {4}!",
      "{4} is seen coming out of {6} car when {0} ambushes {5}! {0} beats down {4} and throws {5} into the car window!"
    ],
    "choicesTag": [
      "{4} are walking into the arena when {0} attack {5} from behind! Superstars scramble backstage to get {0} away from {4}.",
      "{0} are seen walking into {4}'s locker room. A scuffle is heard as cameras rush in to see {0} beating the hell out of {4}!",
      "{4} are seen coming out of {6} car when {0} ambush {5}! {0} beat down {4} and throw {5} into the car window!"
    ]
  },
  "Retirement Ceremony": {
    "start": "{0} is out in the ring and the fans won't stop chanting {2} name ...",
    "action": "Friends and management come out to honor {1}. {0} wipes {2} cheeks as everyone applauds."
  },
  "Losing Streak Promo": {
    "start": "{0} is out in the ring counting {2} recent losses ...",
    "action": "{0} vows to break the losing streak in {2} next match!"
  },
  "Legendary Endorsement": {
    "start": "{4} is here and is coming down to the ring!",
    "action": "{4} calls out {0}, praises {2} recent work and endorses {1}!"
  },
  "Legendary Beatdown": {
    "start": "{4} is out in the ring thanking the fans for welcoming {5} back ...",
    "action": "{0} comes down to the ring and launches an attack on {4}! {0} viciously beats {4} down as officials try to pull {1} away."
  },
  "I'm The Face": {
    "start": "{0} comes out to the ring and talks about {2} recent achievements ...",
    "startTag": "{0} come out to the ring and talk about {2} recent achievements ...",
    "action": "{0} declares {2} right to be a face of this company!",
    "actionTag": "{0} declare {2} right to be faces of this company!"
  },
  "Best Wrestler Promo": {
    "start": "{0} comes out to the ring with the Wrestler of the Year trophy ...",
    "action": "{0} talks about finally getting recognized for being the best wrestler in the world and lifts the trophy over {2} head!"
  },
  "Trophy Destruction": {
    "start": "{0} comes out to the ring with {2} recently won trophy ...",
    "startTag": "{0} come out to the ring with {2} recently won trophy ...",
    "action": "{0} is talking about {2} award win when {4} shows up and attacks {0}. {4} picks up the trophy, throws it outside the ring and proceeds to smash it to pieces against the floor!",
    "actionTag": "{0} are talking about {2} award win when {4} show up and attack {0}. {4} pick up the trophy, throw it outside the ring and proceed to smash it to pieces against the floor!"
  },
  "Injury Gloat": {
    "start": "{0} comes out to the ring with a mic in {2} hands ...",
    "startTag": "{0} come out to the ring with mics in {2} hands ...",
    "action": "{0} talks about how good it felt to injure and take out {4}.",
    "actionTag": "{0} talk about how good it felt to injure and take out {4}."
  },
  "Retirement Gloat": {
    "start": "{0} comes out to the ring with a mic in {2} hands ...",
    "startTag": "{0} come out to the ring with mics in {2} hands ...",
    "action": "{0} gloats about retiring {4}. The fans boo as {3} tells them they will never see {4} wrestle again.",
    "actionTag": "{0} gloat about retiring {4}. The fans boo as {3} tells them they will never see {4} wrestle again."
  },
  "New Heel Promo": {
    "start": "{0} comes out to the answer the question everyone's been asking: 'Why?' ...",
    "startTag": "{0} come out to the answer the question everyone's been asking: 'Why?' ...",
    "action": "{0} talks about how the fans and {4} let {1} down. {0} says {2} time for needing anyone's support is over.",
    "actionTag": "{0} talk about how the fans and {4} let {1} down. {0} says {2} time for needing anyone's support is over."
  },
  "New Babyface Promo": {
    "start": "{0} comes out to the ovation of the fans ...",
    "startTag": "{0} come out to the ovation of the fans ...",
    "action": "{0} talks about having new priorities and moving on from {2} past. The fans applaud and {0} takes it in.",
    "actionTag": "{0} talk about having new priorities and moving on from {2} past. The fans applaud and {0} take it in."
  },
  "New Gimmick Package": {
    "start": "A video package airs about {0} ...",
    "action": "It introduced a new character for {0}.",
    "actionTag": "It introduced new characters for {0}."
  },
  "I Quit": {
    "start": "{0} comes out to the ring looking frustrated ...",
    "startTag": "{0} come out to the ring looking frustrated ...",
    "action": "{0} divulges {2} frustrations with the company and informs the fans of not wanting to be here anymore. {0} says \"I Quit\"!",
    "actionTag": "{0} divulge {2} frustrations with the company and inform the fans of not wanting to be here anymore. {0} say \"We Quit\"!"
  },
  "Better Together": {
    "start": "{0} comes out to the ring and calls out {4} ...",
    "action": "{0} says that despite their differences, they are better together. {4} looks on with mistrust but finally agrees and asks to join forces."
  },
  "Police Arrest": {
    "start": "{0} and {4} are shown brawling violently backstage ...",
    "action": "The owner demands them to stop but they bring their scuffle to the ring! Police are brought in to separate them. They put {0} and {4} in handcuffs as they continue to fight!"
  },
  "Retirement Announcement": {
    "start": "{0} comes out to the ring with a distressed look on {2} face ...",
    "startTag": "{0} come out to the ring with a distressed look on {2} faces ...",
    "action": "{0} announces that due to unforeseen developments, {2} in-ring career is now over. The fans are in in disbelief and despair. The retirement sinks in. Slowly, they start to chant {2} name.",
    "actionTag": "{0} announce that due to unforeseen developments, {2} in-ring careers are now over. The fans are in in disbelief and despair. The retirement sinks in. Slowly, they start to chant {2} name."
  },
  "One Last Run": {
    "start": "{0} comes out to the ring to talk about {2} future ...",
    "startTag": "{0} come out to the ring to talk about {2} future ...",
    "action": "{0} says it's time to retire. The fans chant against it. {0} asks for one final match against a Superstar of {2} choosing: {4}. {4} comes down to the ring, accepts and promises to retire {0}.",
    "actionTag": "{0} say it's time to retire. The fans chant against it. {0} ask for one final match against a Team of {2} choosing: {4}. {4} come down to the ring, accept and promise to retire {0}."
  },
  "New Partner": {
    "start": "{0} comes out to address the injury of {2} tag partner ...",
    "action": "{0} says it's time to move on and introduce {2} new tag team partner. {4}'s music hits! {0} declares they will be better than {2} old team and the two of them embrace."
  },
  "Dangerous Attack": {
    "start": "We're waiting for our next match ...",
    "action": "As {4} comes down to the ring, {0} ambushes {5} from behind. {0} places {4}'s neck between a steel chair and stomps the chair! The fans are concerned as a stretcher comes down for {4}.",
    "actionTag": "As {4} come down to the ring, {0} ambush {5} from behind. {0} place {4}'s necks between steel chairs and stomp the chairs! The fans are concerned as stretchers come down for {4}."
  },
  "Strip Champion": {
    "start": "The owner comes out to address the recent situation regarding the champion, {0} ...",
    "startTag": "The owner comes out to address the recent situation regarding the champions, {0} ...",
    "action": "The owner proclaims the need for immediate action and strips {0} of {2} title!",
    "actionTag": "The owner proclaims the need for immediate action and strips {0} of {2} titles!"
  },
  "Laying Down The Law": {
    "start": "The owner comes out to address the recent actions of {0} ...",
    "action": "The owner talks about how {0} must be punished for {2} actions and proceeds to suspend {1} for a month!"
  },
  "Best Company Brag": {
    "start": "The owner of the company comes out to the ring with the Company of the Year trophy ...",
    "action": "The owner brags about winning the award and puts down the competitors!"
  },
  "Proven Winner": {
    "start": "",
    "action": "{0} comes down to the ring and talks about winning the feud against {4} by proving to be better than {5}.",
    "actionTag": "{0} come down to the ring and talk about winning the feud against {4} by proving to be better than {5}."
  },
  "New Alliance": {
    "start": "{0} is out in the ring fighting with {4} ...",
    "action": "{0} seemed to be getting the better of the exchange when {8} and {12} come down to attack {1}! After beating down {0} mercilessly, {4}, {8} and {12} announce the formation of a new alliance."
  },
  "Cryptic Threat": {
    "start": "{0} is shown in a dark room backstage ...",
    "startTag": "{0} are shown in a dark room backstage ...",
    "action": "{0} sends a warning to someone filled with cryptic hints. Who could it be?",
    "actionTag": "{0} send a warning to someone filled with cryptic hints. Who could it be?"
  },
  "Car Explosion": {
    "start": "{0} is seen getting into {2} car backstage ...",
    "action": "As the car takes off, there's a sudden explosion and the car is engulfed in fire! Crew rush to put it out. Everyone is in shock as to what just happened to {0}."
  },
  "Celebrity Beatdown": {
    "start": "{4} is out in the ring! The fans are excited ...",
    "action": "{0} comes out from behind and attacks {4}! {0} picks {4} up and hits {2} finisher on {5}!"
  },
  "Hosedown": {
    "start": "A bunch of superstars are crowding the ring. {0}'s music hits but wait, is that a truck? ...",
    "action": "{3}'s coming out in a lemonade truck! {0} grabs a hose and starts spraying lemonade on everyone in the ring! All the superstars are slipping and falling around."
  },
  "Helicopter Raid": {
    "start": "A helicopter is hovering in the air. Wait, is that {0} in it?! ...",
    "action": "Yes it is! And {3}'s landing on top of {4}'s building! {0} is launching a raid on {4}!"
  },
  "Ring Invasion": {
    "start": "{0} is standing in the ring and says {3} won't leave until {3} gets what he wants ...",
    "action": "Dozens of people storm the ring! {0} says they are taking over the show as the ring fills up with even more people! Security fails to remove anyone and the establishment has no choice but to meet their demands."
  },
  "Love Making": {
    "start": "There's a bed in the ring as {0} comes out with {2} partner ...",
    "action": "They take each others clothes off, get under the covers, and start making love in front of everyone!"
  },
  "Dummy Wrestling": {
    "start": "{0} is calling out anyone in the back to a match. Wait, is that ...",
    "action": "A wrestling doll comes out and {0} proceeds to wrestle the doll! The two have a fantastic match, with great story, tremendous moves and thrilling near-falls. The crowd is on their feet as {0} hits {2} finisher for the win!"
  },
  "Anti-Company Rant": {
    "start": "{0} comes out to the stage with a mic in {2} hands ...",
    "action": "{0} goes on a rant against the company, saying {3} is the best but the company won't let {1} be the top guy. {3} threatens to leave for a competitor and calls the owner an idiot before {2} mic gets cut off."
  },
  "Stunt Dive": {
    "start": "The roster is fighting on the ramp. {0} climbs the titantron to get away from them. That must be 50 feet or more ...",
    "action": "{0} leaps off the titantron onto everyone below! The crowd goes wild!"
  },
  "Timely Rescue": {
    "start": "{0} is backstage, talking to the camera. A staff member is seen walking behind when, suddenly, they collapse. {0} rushes over and starts performing CPR ...",
    "action": "Everyone in the audience is holding their breath. It's announced that the staff member was {4} and this is not part of the show. {0} keeps performing compressions as paramedics arrive. After thorough medical aid, the doctors say {4} will be alright."
  },
  "Handicap Beatdown": {
    "participants": {
      "3": {
        "start": "{0} is out in the ring for a promo ...",
        "startTag": "{0} are out in the ring for a promo ...",
        "action": "{4} and {8} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
      },
      "4": {
        "start": "{0} is out in the ring for a promo ...",
        "startTag": "{0} are out in the ring for a promo ...",
        "action": "{4}, {8} and {12} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
      },
      "5": {
        "start": "{0} is out in the ring for a promo ...",
        "startTag": "{0} are out in the ring for a promo ...",
        "action": "{4}, {8}, {12} and {16} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
      }
    }
  },
  "Rip Off Mask": {
    "start": "{0} is out in the ring when {4} ambushes {1} from behind!",
    "action": "{4} attacks {0} and proceeds to take {2} mask off! {0} pulls away with {2} face in {2} hands while {4} poses with the mask.",
    "startTag": "{0} are out in the ring when {4} ambush {1} from behind!",
    "actionTag": "{4} attack {0} and proceed to take {2} masks off! {0} pull away with {2} faces in {2} hands while {4} pose with the masks."
  },
  "Kicked Out": {
    "start": "{0} are out in the ring. They say they have to make an important announcement ...",
    "action": "{0} turn and attack {1}, throwing {2} out of the ring! It seems like {0} have kicked {1} out of the faction.",
    "startTag": "{0} are out in the ring. They say they have to make an important announcement ...",
    "actionTag": "{0} turn and attack {1}, throwing {2} out of the ring! It seems like {0} have kicked {1} out of the faction."
  },
  "Time To Leave": {
    "start": "{1} comes out to the ring and calls out the rest of {0} ...",
    "action": "{1} says it's time for {2} to leave {0}. The rest of {0} look on as {1} walks away.",
    "startTag": "{1} come out to the ring and call out the rest of {0} ...",
    "actionTag": "{1} say it's time for {2} to leave {0}. The rest of {0} look on as {1} walk away."
  },
  "New Blood": {
    "start": "{0} are standing in the ring, saying they have an exciting announcement ...",
    "action": "They welcome the newest member of {0}. {1} comes out and embraces everyone! {1} has joined {0}.",
    "startTag": "{0} are standing in the ring, saying they have an exciting announcement ...",
    "actionTag": "They welcome the newest members of {0}. {1} come out and embrace everyone! {1} have joined {0}."
  },
  "Our Leader": {
    "start": "{0} are out in the ring to make an announcement ...",
    "action": "{0} introduce their new leader: {1}! {1} grabs a mic and talks about guiding the faction to the top of the company."
  },
  "New Leadership": {
    "start": "{0} are out in the ring to make an announcement ...",
    "action": "{5} says its time for someone else to lead {0} and announces the new leader: {1}! {1} promises to guide the faction to greater heights."
  },
  "Usurped": {
    "start": "{0} are out in the ring. {1} grabs the mic ...",
    "action": "Before saying a word, {1} attacks {5}! The rest of {0} join the attack, supporting {1}'s control over the faction!"
  },
  "Switching Sides": {
    "start": "{0} are out in the ring when {9} come out ...",
    "startTag": "{0} are out in the ring when {9} come out ...",
    "action": "Before they can enter the ring, {1} attacks the other members of {0} from behind! {9} join {2} as they beat down {0} together. {1} embraces the members of {9}!",
    "actionTag": "Before they can enter the ring, {1} attack the other members of {0} from behind! {9} join {2} as they beat down {0} together. {1} embrace the members of {9}!"
  },
  "Joining Forces": {
    "start": "{0} are out in the ring. They call out {5} ...",
    "action": "The two factions stand together and announce that they are joining forces to form \"{6}\"!"
  },
  "Internal Division": {
    "start": "{0} are out in the ring. Looks like they have something on their minds ...",
    "startTag": "{0} are out in the ring. Looks like they have something on their minds ...",
    "action": "{1} blindside the other members of {0}, attacking them from behind! {1} announce that they are splitting from {0} to form \"{10}\"!",
    "actionTag": "{1} blindside the other members of {0}, attacking them from behind! {1} announce that they are splitting from {0} to form \"{10}\"!"
  },
  "No Leadership": {
    "start": "{0} are out in the ring to make an announcement ...",
    "action": "They say that, from now on, {0} will operate without any leadership."
  },
  "Our End": {
    "start": "{0} are out in the ring with something on their minds ...",
    "action": "They announce that this is the end of {0}."
  },
  "New Power": {
    "start": "{1} come out to the ring and stand together ...",
    "startTag": "{1} come out to the ring and stand together ...",
    "action": "They say they have come together to form an alliance. They will be called \"{10}\"!",
    "actionTag": "They say they have come together to form an alliance. They will be called \"{10}\"!"
  },
  "Manager Promo": {
    "start": "{0} is in the ring along with {4} ...",
    "action": "{0}",
    "choices": [
      "{0} praised {4}'s accomplishments.",
      "{0} applauded {4}'s ability and skill.",
      "{0} warned everyone in the back to watch out for {4}.",
      "{0} told the fans that no one can defeat {4}.",
      "{0} talked about {4}'s unmatched talent.",
      "{0} said everyone should watch out for {4}'s next move.",
      "{0} hyped {4}'s unique capabilities.",
      "{4} stood aside as {0} sang {6} praises.",
      "{0} told everyone who is watching that they should be scared of {4}.",
      "{0} spoke about the immense strengths of {4}.",
      "{0} talked about {4}'s greatness and said no one can match {5}.",
      "{0} went on about {4}'s talent and said no one is above {5}.",
      "{0} said no one should think about getting in the way of {4}.",
      "{0} talked about {4} being better than anyone in the locker room.",
      "{4} looked menacing as {0} built {5} up."
    ]
  },
  "Dismiss Manager": {
    "start": "{4} comes out to the ring and calls out {0} ...",
    "action": "{4} says {7} no longer wants {0} as {6} manager and ends their relationship!",
    "startTag": "{4} come out to the ring and call out {0} ...",
    "actionTag": "{4} say {7} no longer want {0} as {6} manager and end their relationship!"
  },
  "Reveal Manager": {
    "start": "{4} is here with an important announcement ...",
    "action": "{0} comes out to stand with {5}, revealing that {3} is the new manager of {4}!",
    "startTag": "{4} are here with an important announcement ...",
    "actionTag": "{0} comes out to stand with {5}, revealing that {3} is the new manager of {4}!"
  },
  "Client Betrayal": {
    "start": "{0} comes into the ring, cheering {4} on ...",
    "action": "As {4} turns around, {0} attacks {5} with a weapon! {4} looks on in shock at {0}.",
    "startTag": "{0} comes into the ring, cheering {4} on ...",
    "actionTag": "As {4} turn around, {0} attacks {5} with a weapon! {4} look on in shock at {0}."
  },
  "Brand Invasion": {
    "start": "There's something going on in the stands ... Wait, that's {0} from {2}!",
    "action": "They storm the ring, fight off incoming {1} superstars and throw them out. The {2} superstars have invaded {1}!"
  },
  "Brand Signing": {
    "start": "{0} is here with some big news ...",
    "action": "{0} says {3} has decided to join {4}! From now on, {0} will be exclusive to the {4} brand.",
    "startTag": "{0} are here with some big news ...",
    "actionTag": "{0} say {3} have decided to join {4}! From now on, {0} will be exclusive to the {4} brand."
  },
  "Backstage Confrontation": {
    "start": "We are backstage for a scheduled interview ...",
    "action": "{4} is talking to the interviewer when {0} interrupts {5}. They get aggressive with each other before officials come in between.",
    "startTag": "We are backstage for a scheduled interview ...",
    "actionTag": "{4} are talking to the interviewer when {0} interrupt {5}. They get aggressive with each other before officials come in between."
  },
  "Off-Camera Assault": {
    "start": "We have a camera backstage with an incident ...",
    "action": "{4} is lying on the floor, battered and bloodied. {0} is seen walking away in the corner of the frame.",
    "startTag": "We have a camera backstage with an incident ...",
    "actionTag": "{4} are lying on the floor, battered and bloodied. {0} are seen walking away in the corner of the frame."
  },
  "Split Interview": {
    "start": "Our interviewer is live with {0} and {4} in separate locations ...",
    "action": "The conversation got heated as they argued and verbally attacked each other.",
    "startTag": "Our interviewer is live with {0} and {4} in separate locations ...",
    "actionTag": "The conversation got heated as they argued and verbally attacked each other."
  },
  "Solo Feud Promo": {
    "start": "{0} is in the ring for a promo ...",
    "startTag": "{0} are in the ring for a promo ...",
    "action": "{0}",
    "choices": [
      "{0} talked about how {3} will embarass {4} soon.",
      "{0} described the many ways in which {3} will enjoy beating up {4}.",
      "{0} listed all the ways that {3} is better than {4}.",
      "{0} insulted {4} and {6} hometown.",
      "{0} explained to the fans how {4} is a disgrace to the wrestling industry.",
      "{0} disclosed {2} unpleasant history with {4} to the fans.",
      "{0} told the fans a story about how {4} is a terrible person.",
      "{0} made things personal with {4} by bringing up {6} family.",
      "{0} called {4} a loser and other things that are too vile to be repeated.",
      "{0} promised the fans that not only will {3} defeat {4}, but {3} will also humiliate {5}.",
      "{0} went off on {4}, berating {5} for everything {7} has done.",
      "{0} talked about being a better wrestler than {4} and promised to prove it."
    ],
    "choicesTag": [
      "{0} talked about how {3} will embarass {4} soon.",
      "{0} described the many ways in which {3} will enjoy beating up {4}.",
      "{0} listed all the ways that {3} are better than {4}.",
      "{0} insulted {4} and {6} hometown.",
      "{0} explained to the fans how {4} are a disgrace to the wrestling industry.",
      "{0} disclosed {2} unpleasant history with {4} to the fans.",
      "{0} told the fans a story about how {4} are terrible people.",
      "{0} made things personal with {4} by bringing up {6} family.",
      "{0} called {4} losers and other things that are too vile to be repeated.",
      "{0} promised the fans that not only will {3} defeat {4}, but {3} will also humiliate {5}.",
      "{0} went off on {4}, berating {5} for everything {7} have done.",
      "{0} talked about being better wrestlers than {4} and promised to prove it."
    ]
  },
  "Staredown": {
    "start": "{4} is in the ring cutting a promo when {0}'s music hits!",
    "action": "{0} comes face to face with {4} and they have an intense staredown.",
    "startTag": "{4} are in the ring cutting a promo when {0}'s music hits!",
    "actionTag": "{0} come face to face with {4} and they have an intense staredown."
  },
  "Fight Tease": {
    "start": "{0} and {4} are talking in the ring. Tensions are getting high ...",
    "action": "{0} teases a fight but backs out of the ring at the last minute.",
    "startTag": "{0} and {4} are talking in the ring. Tensions are getting high ...",
    "actionTag": "{0} tease a fight but back out of the ring at the last minute."
  },
  "Forced To Retreat": {
    "start": "{0} and {4} are in the ring, talking. They say some insulting things to each other ...",
    "action": "A fight breaks out. {0} has {4} ready for {2} finisher but {4} is able to escape from the ring!",
    "startTag": "{0} and {4} are in the ring, talking. They say some insulting things to each other ...",
    "actionTag": "A fight breaks out. {0} have {4} ready for {2} finisher but {4} are able to escape from the ring!"
  },
  "Standing Tall": {
    "start": "{0} and {4} are talking to each other in the ring. It's getting hostile ...",
    "action": "They start brawling! {0} gets the upper hand and hits {2} finisher on {4} to stand tall!",
    "startTag": "{0} and {4} are talking to each other in the ring. It's getting hostile ...",
    "actionTag": "They start brawling! {0} get the upper hand and hit {2} finisher on {4} to stand tall!"
  },
  "Tense Pull-Apart": {
    "start": "{0} and {4} are out talking in the ring. Things are getting intense between them ...",
    "action": "They start fighting! Officials run in to pull them apart but they can barely contain the two!",
    "startTag": "{0} and {4} are out talking in the ring. Things are getting intense between them ...",
    "actionTag": "They start fighting! Officials run in to pull them apart but they can barely contain the teams!"
  },
  "Surprise Attack": {
    "start": "We're in the ring, waiting to hear from a superstar ...",
    "action": "{4} is talking on the mic when {0} sneaks in from behind to attack {5}! {0} beats down {4} and leaves {5} laying in the ring.",
    "startTag": "We're in the ring, waiting to hear from a superstar ...",
    "actionTag": "{4} are talking on the mic when {0} sneak in from behind to attack {5}! {0} beat down {4} and leave {5} laying in the ring."
  },
  "After Match Attack": {
    "start": "We just finished our last match ...",
    "action": "{4} is going to leave after {6} match when {0} attacks {5} from behind! {0} lays {4} out and exits the ring.",
    "startTag": "We just finished our last match ...",
    "actionTag": "{4} are going to leave after {6} match when {0} attack {5} from behind! {0} lay {4} out and exit the ring."
  },
  "After Match Save": {
    "start": "The match is over ...",
    "action": "{4} is attacking {6} opponent when {0}'s music hits! {0} charges down to the ring as {4} retreats.",
    "startTag": "The match is over ...",
    "actionTag": "{4} are attacking {6} opponent when {0}'s music hits! {0} charge down to the ring as {4} retreat."
  },
  "Interview Attack": {
    "start": "We're backstage with an interview ...",
    "action": "{4} is talking when {0} ambushes {5} from behind! {0} continues the attack until officials are able to force {1} away.",
    "startTag": "We're backstage with an interview ...",
    "actionTag": "{4} are talking when {0} ambush {5} from behind! {0} continue the attack until officials are able to force {1} away."
  },
  "Spouse Attack": {
    "start": "",
    "action": "{4} is in the ring with {6} spouse when {0} knocks out {4} from behind and then attacks {6} spouse! {4} crawls to {6} spouse as {0} walks away.",
    "startTag": "",
    "actionTag": "{4} are in the ring with {6} spouse when {0} knock out {4} from behind and then attack {6} spouse! {4} crawl to {6} spouse as {0} walk away."
  },
  "Desecrate Grave": {
    "start": "A camera is outside where it's dark and gloomy. We seem to be in a graveyard ...",
    "action": "{0} is standing next to a grave. The camera pans to the tombstone, revealing it belongs to a family member of {4}. {0} mocks the dead and then vandalizes the grave!",
    "startTag": "A camera is outside where it's dark and gloomy. We seem to be in a graveyard ...",
    "actionTag": "{0} are standing next to a grave. The camera pans to the tombstone, revealing it belongs to a family member of {4}. {0} mock the dead and then vandalize the grave!"
  },
  "Debut Promo": {
    "start": "We're in the ring when the lights go out and someone's music hits ...",
    "startTag": "We're in the ring when the lights go out and someone's music hits ...",
    "action": "{0}",
    "choices": [
      "It's {0}! {0} comes out to the cheering of the fans and says {3} has joined the best wrestling company!",
      "{0} is here! {0} arrives to the ovation of the fans and talks trash about {2} previous employer!",
      "It's {0}! {0} comes down to the applause of the fans and says {3} is going to shake this company up!",
      "{0} is here! {0} comes out to the cheering of the fans and puts everyone on the roster on notice!",
      "It's {0}! {0} arrives to the ovation of the fans and says {3} is the best superstar in this company!"
    ],
    "choicesTag": [
      "It's {0}! {0} come out to the cheering of the fans and say {3} have joined the best wrestling company!",
      "{0} are here! {0} arrive to the ovation of the fans and talk trash about {2} previous employer!",
      "It's {0}! {0} come down to the cheering of the fans and say {3} are going to shake this company up!",
      "{0} are here! {0} come out to the cheering of the fans and put everyone on the roster on notice!",
      "It's {0}! {0} arrive to the ovation of the fans and say {3} are the best team in this company!"
    ]
  },
  "Debut Attack": {
    "start": "{4} is in the ring cutting a promo when the lights go out ...",
    "action": "It's {0}! {0} attacks {4} and takes {5} out! The fans are in shock as {0} walks away.",
    "startTag": "{4} are in the ring cutting a promo when the lights go out ...",
    "actionTag": "It's {0}! {0} attack {4} and take {5} out! The fans are in shock as {0} walk away."
  },
  "Indifferent Promo": {
    "start": "{0} is in the ring for a promo ...",
    "startTag": "{0} are in the ring for a promo ...",
    "action": "{0}",
    "choices": [
      "{0} told the fans {3} doesn't care whether they cheer {1} or boo {1}.",
      "{0} said {3} doesn't know if {3} is a good person or a bad person, but does know that {3} is the best.",
      "{0} talked about doing whatever {3} wants, regardless of what people think.",
      "{0} spoke about being the best performer in the company.",
      "{0} told the fans {3} doesn't care what they think about {1}.",
      "{0} talked about doing things that other people wouldn't have the guts to do.",
      "{0} promised the fans that {3} will never change who {3} is."
    ],
    "choicesTag": [
      "{0} told the fans {3} don't care whether they cheer {1} or boo {1}.",
      "{0} said {3} don't know if {3} are good people or bad people, but do know that {3} are the best.",
      "{0} talked about doing whatever {3} want, regardless of what people think.",
      "{0} spoke about being the best performers in the company.",
      "{0} told the fans {3} don't care what they think about {1}.",
      "{0} talked about doing things that other people wouldn't have the guts to do.",
      "{0} promised the fans that {3} will never change who {3} are."
    ]
  },
  "Catchphrase Showdown": {
    "start": "{0} and {4} are in the ring, mics in hand, ready to go ...",
    "action": "They used their catchphrases against each other and hurled some major insults!"
  },
  "Cutting Ties": {
    "participants": {
      "2": {
        "start": "{0} and {4} are in the ring to discuss their future ...",
        "action": "They announce that they will no longer team together and walk away."
      },
      "3": {
        "start": "{0}, {4} and {8} are in the ring to discuss their future ...",
        "action": "They announce that they will no longer team together and walk away."
      }
    }
  },
  "New Association": {
    "participants": {
      "2": {
        "start": "{0} is in the ring when {4} comes out to join {1} ...",
        "action": "They agree on having a common goal and decide to form a team with each other."
      },
      "3": {
        "start": "{0} is in the ring when {4} and {8} come out to join {1} ...",
        "action": "They agree on having a common goal and decide to form a team with each other."
      }
    }
  },
  "Face Reveal": {
    "start": "{0} is standing in the middle of the ring, looking hesitant ...",
    "action": "{0} takes off {2} mask to reveal {2} face! The crowd looks on in shock.",
    "startTag": "{0} are standing in the middle of the ring, looking hesitant ...",
    "actionTag": "{0} take off {2} mask to reveal {2} faces! The crowd looks on in shock."
  },
  "Righteous Beatdown": {
    "start": "{0} and {4} are out in the ring for a promo ...",
    "action": "After {4} says some nasty things, {0} gets angry and attacks {5}! {0} beats {4} up as the crowd cheers {1} on!",
    "startTag": "{0} and {4} are out in the ring for a promo ...",
    "actionTag": "After {4} say some nasty things, {0} get angry and attack {5}! {0} beat {4} up as the crowd cheers {1} on!"
  },
  "Title Unification": {
    "start": "The owner comes out to the ring with {0} ...",
    "action": "The owner announces that {0}'s Championships will be unified and presents {0} with the single new Championship!",
    "startTag": "The owner comes out to the ring with {0} ...",
    "actionTag": "The owner announces that {0}'s Championships will be unified and presents {0} with the single new Championships!"
  },
  "Surprise Return": {
    "start": "The owner is in the ring to announce someone's return ...",
    "action": "{0}'s music hits and the fans go crazy! They're on their feet as {3} comes down to the ring, soaking it all in.",
    "startTag": "The owner is in the ring to announce someone's return ...",
    "actionTag": "{0}'s music plays! {0} are back! The fans are on their feet as {3} come down to the ring, soaking it all in."
  },
  "Return Attack": {
    "start": "{4} is in the ring when some familiar music plays ...",
    "action": "It's {0}! {0} has returned from injury! The fans are going crazy as {0} comes down to the ring and takes {4} out!",
    "startTag": "{4} are in the ring when some familiar music plays ...",
    "actionTag": "It's {0}! {0} have returned from injury! The fans are going crazy as {0} come down to the ring and take {4} out!"
  },
  "Retirement Fakeout": {
    "start": "{4} is in the ring when {0} comes out with an uneasy look on {2} face ...",
    "action": "{0} gets choked up as {3} talks about {2} career and announces that it's time to retire. Loud chants erupt for {1}. {4} goes to raise {2} hand but {0} attacks {4} and lays {5} out!",
    "startTag": "",
    "actionTag": ""
  },
  "TGI Victory Boast": {
    "start": "{0} comes out to the ring holding the TGI trophy ...",
    "action": "{0} talks about the importance of winning The Grand Invitational for the company and lifts the trophy up high!"
  }
};

let segmentItemsOrder = [
    // Repeatable
    "Backstage Interview",
    "Fight",
    "Promo Battle",
    "Solo Feud Promo",
    "Spirited Promo",
    "Heat Promo",
    "Indifferent Promo",

    // No requirement/consequence
    "Slander Competitor",
    "Backstage Confrontation",
    "Off-Camera Assault",
    "Split Interview",
    "Staredown",
    "Fight Tease",
    "Forced To Retreat",
    "Standing Tall",
    "Tense Pull-Apart",
    "Surprise Attack",
    "After Match Attack",
    "After Match Save",
    "Interview Attack",
    "Backstage Attack",
    "Promo Ambush",
    "Handicap Beatdown",
    "Contract Signing",
    "Kidnapping",
    "Desecrate Grave",
    "Masked Attacker",
    "Unlikely Partners",
    "Push-up Contest",
    "Home Invasion",
    "Spouse Attack",
    "Car Destruction",
    "Smack Talk",
    "Catchphrase Showdown",
    "Epic Brawl",
    "Local Squash",
    "This Is My Life",
    "Talk Show",

    // Consequence/Requirement
    "Dangerous Attack",
    "Police Arrest",
    "Rip Off Mask",
    "Trophy Destruction",
    "Cryptic Threat",
    "Debut",
    "Debut Promo",
    "Debut Attack",
    "Surprise Return",
    "Return Attack",
    "Proven Winner",
    "Moving On",
    "Mutual Respect",
    "Best Wrestler Promo",
    "Best Company Brag",
    "I'm The Face",
    "Build Honor",
    "Villainize",
    "Neutralize",
    "Injury Gloat",
    "Losing Streak Promo",
    "Demand Title Shot",
    "Title Disrespect",
    "Cash-In Tease",
    "Title Destruction",
    "Champion Coronation",
    "Title Unification",
    "Championship Split",
    "New Title Reveal",
    "Option C",
    "New Association",
    "Cutting Ties",
    "New Alliance",
    "New Partner",
    "Better Together",
    "Team Tension",
    "Vicious Beatdown",
    "Righteous Beatdown",
    "Backstab",
    "Defying a Villain",
    "Beatdown Save",
    "Joining the Devil",
    "Delayed Vengeance",
    "Forgiveness",
    "New Heel Promo",
    "New Babyface Promo",
    "Retirement Ceremony",
    "Retirement Fakeout",
    "One Last Run",
    "Retirement Announcement",
    "Retirement Gloat",
    "Legendary Beatdown",
    "Legendary Endorsement",
    "Legend's Praise",
    "Competitor Buyout",
    "Laying Down The Law",
    "Strip Champion",
    "This Belongs To You",
    "I Quit",
    "Face Reveal",
    "You're Fired",
    "Lost My Smile",

    // Production
    "Video Package",
    "Feud Package",
    "Event Package",
    "Main Event Package",
    "Recap Package",
    "Champion Package",
    "Debut Package",
    "New Gimmick Package",
    "Return Package",
    "Career Package",
    "Day in the Life",

    // Manager/faction/brand
    "Manager Promo",
    "Reveal Manager",
    "Dismiss Manager",
    "Client Betrayal",
    "Kicked Out",
    "Time To Leave",
    "New Blood",
    "Our Leader",
    "Usurped",
    "New Leadership",
    "Switching Sides",
    "Joining Forces",
    "Internal Division",
    "No Leadership",
    "Our End",
    "New Power",
    "Brand Signing",
    "Brand Invasion",

    // Silly
    "Singing Contest",
    "Slime Surprise",
    "Spooky Trick",
    "Backstage BBQ",
    "Midget Impersonation",
    "Anger Management",
    "Entrance Parody",
    "Siblings Parody",
    "Bodybuilding Contest",
    "Spouse Affair",
    "Exposing the Past",

    // Special
    "Car Explosion",
    "Timely Rescue",
    "Stunt Dive",
    "Anti-Company Rant",
    "Dummy Wrestling",
    "Love Making",
    "Ring Invasion",
    "Helicopter Raid",
    "Hosedown",
    "Celebrity Beatdown",
];

export {segmentsData, segmentItemsOrder, specialSegmentCelebritiesData}